<template>
  <div class="">
    <ClubForm :resource="resource" />
  </div>
</template>

<script>
import { ClubTeamHighlight } from "@/models";
import ClubForm from "./form";

export default {
  components: {
    ClubForm
  },
  data() {
    return {
      resource: new ClubTeamHighlight()
    };
  }
};
</script>

<style lang="sass" scoped></style>
